import * as React from "react";
const SvgCircle16 = (props) => /* @__PURE__ */ React.createElement("svg", { width: 17, height: 16, viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 8.5, cy: 8, r: 7.5, fill: "white", stroke: "#9A00FF" }));
export default SvgCircle16;
